// extracted by mini-css-extract-plugin
export default {"link-list":"horizontallinklist-module_link-list_xUXVBGO9","within-banner":"horizontallinklist-module_within-banner__LLMU2FZ"};